import productViewHtml from './productview.component.html';
import './productview.component.scss';

class ProductViewController {
    constructor($scope, $location, $http, $filter, $q, $httpParamSerializer, SnackbarService, CartService, ModalService, ProductViewService) {
        'ngInject';

        this.$scope = $scope;
        this.$location =  $location;
        this.$http = $http;
        this.$filter = $filter;
        this.$q = $q;
        this.$httpParamSerializer = $httpParamSerializer;
        this.SnackbarService = SnackbarService;
        this.ModalService = ModalService;
        this.CartService = CartService;
        this.ProductViewService = ProductViewService;
        this.loading = false;

        this.imagesUrls = [];
        this.currentImage = null;
        this.attributes = new Map();
        this.colors = new Map();
        this.price = {
            from: false,
            catalog_price: 0,
            price_old_gros: 0,
            price_gros: 0,
            omnibus_lowest_price: 0
        };
        this.availability = {
            min: false,
            name: "",
            quantity: ""
        };
        this.productCode = null;
        this.eanCode = null;
        this.selectedColorId = null;
        this.selectedAttributes = new Map();
        this.selectedComplementaryProduct = null;
        this.quantity = 1;
        this.filtersOrder = [
            {type: 'attribute', id: 16}, // Rodzaj ramy
            {type: 'color', id: 0}, // Kolor
            {type: 'attribute', id: 1}, // Biegi
            {type: 'attribute', id: 123}, // Bagażnik
            {type: 'attribute', id: 14} // Rozmiar ramy
        ];
        this.filters = [];
        this.frameAttributeId = 16;
    }

    get canBuy() {
        if (this.variants && this.variants.length > 0) {
            if (!this.selectedVariant) return false;

            const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

            if (matches.length < 1) return false;

            if (matches[0].can_buy == '0') return false;
        } else {
            if (this.product.can_buy == '0') return false;
        }


        return true;
    }

    get name() {
        if (this.selectedVariant) {
            const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

            return `${this.product.name} - ${matches[0].name}`;
        } else {
            return this.product.name;
        }
    }

    get defaultPhoto() {
        return this.chooseDefaultImage();
    }

    $onInit() {
        this.$scope.$on("$locationChangeSuccess", (event, newUrl, oldUrl) => {
            if (newUrl == oldUrl) return;
            if (!this.variants || this.variants.length < 1) return;

            let segments = newUrl.split('/');
            let segmentsOld = oldUrl.split('/');

            // No selected variant
            if (segmentsOld.length > segments.length) {
                this.selectVariant(null);
                return;
            }

            const slug = segments[segments.length - 1];
            let matches = this.variants.filter(variant => variant.slug == slug);

            if (this.selectedColorId && matches.length > 1) {
                matches = matches.filter(variant => parseInt(variant.color_id) == this.selectedColorId);
            }

            if (matches.length < 1) return;

            if (this.selectedVariant && parseInt(matches[0].id) == this.selectedVariant) {
                return;
            }

            this.selectVariant(matches[0]);
        });

        this.imagesUrls = this.images.map(image => image.url);

        this.price = {
            from: false,
            catalog_price: this.product.catalog_price,
            price_old_gros: this.product.old_price,
            price_gros: this.product.price_gros,
            omnibus_lowest_price: this.product.omnibus_lowest_price
        };

        this.availability = {
            id: this.product.avail_id,
            name: this.product.displayed_availability,
            quantity: this.product.quantity
        };

        if (this.product.product_code && this.product.product_code != '') {
            this.productCode = this.product.product_code;
        }

        if (this.product.barcode && this.product.barcode != '') {
            this.eanCode = this.product.barcode;
        }

        this.chooseDefaultImage();

        this.ProductViewService.setProduct(this.product);
        this.ProductViewService.setPrice(this.price);

        // Check if product has variants
        if (!this.variants || this.variants.length < 1) return;

        this.price.from = true;
        this.price.price_gros = this.product.min_price;

        this.availability.name = null;
        this.availability.quantity = null;
        this.productCode = null;
        this.eanCode = null;

        console.log('$onInit() attributesToFilter', this.attributesToFilter);

        if (this.attributesToFilter && this.attributesToFilter.length) {
            for (const attributeId of this.attributesToFilter) {
                this.selectedAttributes.set(attributeId, -1);
            }
        }

        console.log('$onInit() variants', this.variants);

        let possibleAttributes = new Map();

        if (this.attributesToFilter && this.attributesToFilter.length) {
            this.variants.forEach(variant => {
                if (!variant.attributes || variant.attributes.length === 0) {
                    return;
                }
                variant.attributes.forEach(attribute => {
                    if (this.attributesToFilter.indexOf(parseInt(attribute.attribute_id)) !== -1) {
                        possibleAttributes.set(attribute.attribute_id, '1');
                    }
                });
            });

            // Remove invalid variants

            this.variants = this.variants.filter(variant => {
                if (!variant.attributes && this.attributes.length > 0) {
                    return false;
                }
                let variantIsValid = true;
                for (const attributeId of possibleAttributes.keys()) {
                    variantIsValid = variantIsValid && this.variantHasAttribute(variant, attributeId);
                }
                if (!variantIsValid) {
                    console.log('$onInit() variant_id = ' + variant.id + ' is invalid (missing attributes)');
                }
                return variantIsValid;
            });
        }

        //

        for (const variant of this.variants) {
            if (variant.color_id && parseInt(variant.color_id) != 0) {
                if (!this.colors.has(parseInt(variant.color_id))) {
                    this.colors.set(parseInt(variant.color_id), {
                        name: variant.color.name,
                        hex: variant.color.hex,
                        hex_additional: variant.color.hex_additional || null,
                        available: (parseInt(variant.can_buy) == 1)
                    });
                } else {
                    const color = this.colors.get(parseInt(variant.color_id));

                    if (parseInt(variant.can_buy) === 1 && !color.available) {
                        color.available = true;
                    }
                }
            }

            if (!variant.attributes || variant.attributes.length < 1) continue;

            for (const attribute of variant.attributes) {
                const attributeId = parseInt(attribute.attribute_id);

                if (this.attributesToFilter.indexOf(attributeId) < 0) {
                    continue;
                }

                const value = {
                    id: parseInt(attribute.value_id),
                    name: attribute.value_name,
                    available: true,
                    order: parseInt(attribute.sort)
                }

                if (this.attributes.has(attributeId)) {
                    const values = this.attributes.get(attributeId).values;
                    const matches = values.filter(v => v.id == value.id);

                    if (matches.length > 0) continue;

                    values.push(value);
                } else {
                    this.attributes.set(attributeId, {
                        name: attribute.attribute_name,
                        values: [value]
                    });
                }
            }
        }

        console.log('$onInit() available colors', this.colors);
        console.log('$onInit() available attributes', this.attributes);

        // Add attributes and colors to the filters

        this.filters.push({type: 'color', id: 0, data: this.colors});
        for(const attribute of this.attributes) {
            this.filters.push({type: 'attribute', id: attribute[0], data: attribute[1]});
        }

        // Sort the filters by a filters.Order object data

        this.filters.sort((filter1, filter2) => {
            let filters = [{filter: filter1, order: -1} , {filter: filter2, order: -1}];
            for(const filter of filters) {
                for(const [index, filterOrder] of this.filtersOrder.entries()) {
                    if(filterOrder.type === filter.filter.type && filterOrder.id === filter.filter.id) {
                        filter.order = index;
                    }
                }
            }
            if(filters[0].order > filters[1].order) {
                return 1;
            }

            return -1;
        });

        if (this.selectedVariant) {
            const matches = this.variants.filter(variant => variant.id == this.selectedVariant);

            this.selectVariant(matches[0]);

            if (matches[0].color_id) {
                this.selectedColorId = parseInt(matches[0].color_id);
            }

            for (const attributeId of this.attributesToFilter) {
                const attributes = matches[0].attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                if (!attributes || attributes.length < 1) continue;

                this.selectedAttributes.set(attributeId, attributes[0].value_id);
            }
        }

        if(this.complementaryProducts) {
            this.selectedComplementaryProduct = this.$filter('orderBy')(this.complementaryProducts, 'price_gros', true).pop();
            console.log('$onInit() complementaryProducts', this.complementaryProducts);
        }

        this.checkAttributesAvaibilityForFrame();
        this.checkAttributesMatching();
        this.checkAttributesAvaibility();

        if (typeof window.gtag === 'undefined') {
            return;
        }

        // Fallback to product/variant ID
        let productCode = this.product.id;

        if (this.selectedVariant) {
            productCode = this.selectedVariant.id;
        }

        if (this.productCode) {
            productCode = this.productCode;
        }

        console.log(`gtag::event::view_item -> wyświetlenie -> ${productCode}`);

        let productPrice = this.product.price_gros.toString();
        const productName = this.name;
        const productCategoryName = this.product.category_name;

        window.gtag('event', 'view_item', {
            "items": [
                {
                    "id": productCode,
                    "name": productName,
                    "category": productCategoryName,
                    "price": parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2'))
                }
            ]
        });
    }

    getFrameDescription(frameName) {
        if (this.framesDescription && typeof (this.framesDescription[frameName]) !== 'undefined') {
            return this.framesDescription[frameName];
        }
        return null;
    }

    variantHasAttribute(variant, attributeId) {
        if(!variant.attributes || variant.attributes.length === 0) {
            return false;
        }
        let hasAttribute = false;

        variant.attributes.forEach((attribute) => {
            if(parseInt(attribute.attribute_id) === parseInt(attributeId)) {
                hasAttribute = true;
            }
        });

        return hasAttribute;
    }

    complementaryProductChanged() {
        console.log('complementaryProductChanged');
        this.calculatePrice();
    }

    selectColorAttribute(id) {
        this.selectedColorId = id;
        console.log('$selectColorAttribute()', id);
        this.checkAttributesMatching('color', 0);
        this.checkAttributesAvaibilityForFrame();
        this.checkAttributesAvaibility();
    }

    selectAttribute(attributeId, valueId) {
        this.selectedAttributes.set(attributeId, valueId);
        console.log('selectAttribute', attributeId, valueId);
        this.checkAttributesMatching('attribute', attributeId);
        this.checkAttributesAvaibilityForFrame();
        this.checkAttributesAvaibility();
    }

    checkAttributesMatching(attributeType, attributeId = null, step = 1) {

        let selectedAttributes = new Map();
        let validVariants = this.variants;

        this.selectedAttributes.forEach((value, key) => {
            if(value > 0) {
                selectedAttributes.set(key, value);
            }
        });

        validVariants = this.variants.filter(variant => {
            let valid = true;
            if(this.selectedColorId && parseInt(variant.color_id) !== parseInt(this.selectedColorId)) {
                return false;
            }
            selectedAttributes.forEach((attribute_value, attribute_id) => {
                valid = valid && this.variantHasAttributeValue(variant, attribute_id, attribute_value);
            });
            return valid;
        });

        if(validVariants.length === 0) {
            // Matching variants not found - remove selected attribute by attribute order and search again
            let lastMatchedFilter = this.filtersOrder.find(filter => filter.type === attributeType && filter.id === attributeId);
            let tmpFiltersOrder = this.filtersOrder.filter(filter => filter !== lastMatchedFilter);
            tmpFiltersOrder = tmpFiltersOrder.reverse();
            if(lastMatchedFilter) {
                tmpFiltersOrder.push(lastMatchedFilter);
            }

            const filterToRemove = tmpFiltersOrder.find(filter => {
                switch(filter.type) {
                    case 'color':
                        if(this.selectedColorId) {
                            return true;
                        }
                        break;
                    case 'attribute':
                        if(selectedAttributes.has(filter.id)) {
                            return true;
                        }
                        break;
                }
            });

            if(filterToRemove) {
                if (filterToRemove.type === 'color') {
                    this.selectedColorId = null;
                } else {
                    this.selectedAttributes.set(filterToRemove.id, -1);
                }
                if (filterToRemove && step < 20) {
                    return this.checkAttributesMatching(attributeType, attributeId, ++step);
                }
            }
        }

        let bestMatches = validVariants;

        this.attributes.forEach((attribute, attributeId) => {
            let firstMatchedValue = null;
            let attributeValues = [];
            attribute.values.forEach(value => {
                attributeValues.push({name: value.name, id: value.id});
            });
            attributeValues = attributeValues.sort((value1, value2) => {
                return value1.name > value2.name ? 1 : -1;
            });

            attributeValues.forEach(value => {
                bestMatches = bestMatches.filter(variant => {
                    let filter = true;
                    variant.attributes.forEach(variantAttribute => {
                        if(parseInt(attributeId) === parseInt(variantAttribute.attribute_id)
                            && parseInt(value.id) === parseInt(variantAttribute.value_id)) {
                            if(!firstMatchedValue || firstMatchedValue === parseInt(variantAttribute.value_id)) {
                                firstMatchedValue = parseInt(variantAttribute.value_id);
                            } else {
                                filter = false;
                            }
                        }
                    });
                    return filter;
                })
            })
        })

        if(bestMatches) {
            validVariants = bestMatches;
        }

        validVariants[0].attributes.forEach(attribute => {
            if(this.attributesToFilter.includes(parseInt(attribute.attribute_id))) {
                this.selectedAttributes.set(parseInt(attribute.attribute_id), parseInt(attribute.value_id));
            }
        });

        this.selectedColorId = parseInt(validVariants[0].color_id);

        this.selectVariant(validVariants[0]);
    }

    variantHasAttributeValue(variant, attributeId, attributeValue) {
        let valueExists = false;

        variant.attributes.forEach(attribute => {
            if(parseInt(attribute.attribute_id) === parseInt(attributeId) &&
                parseInt(attribute.value_id) === parseInt(attributeValue)) {
                valueExists = true;
            }
        });

        return valueExists;
    }



    showSizeTable() {
        const modalRef = this.ModalService.add(
            'Tabela rozmiarów marki ' + this.product.producer,
            `<div class="product-table-size">${this.sizeTable}</div>`,
            null,
            true,
            'table-size-modal'
        );

        modalRef.open();
    }

    availabilityQuestion(variantId) {
        let productName;

        if (variantId) {
            const matches = this.variants.filter(variant => variant.id == variantId);

            if (typeof matches[0] !== 'undefined') {
                productName = `${this.product.name} - ${matches[0].name}`;
            } else {
                productName = `${this.product.name} (wariant: ${variantId})`;
            }
        } else {
            productName = this.product.name;
        }

        const modalRef = this.ModalService.add(
            'Powiadomienie o dostępności',
            `<product-view-availability-question product-id="${this.product.id}" variant-id="${variantId}" product-name="'${productName}'" attribute-id="0" attribute-value-id="0"></product-view-availability-question>`
        );

        modalRef.open();
    }

    availabilityQuestionAttribute(attributeId, valueId, attributeName, valueName) {
        let availableVariants = this.variants;

        if (this.selectedColorId) {
            availableVariants = availableVariants.filter(variant => parseInt(variant.color_id) == this.selectedColorId);
        }

        const availableVariantsForAttribute = availableVariants.filter(
            variant => {
                const attributes = variant.attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                if (!attributes || attributes.length < 1) {
                    return false;
                }

                if (parseInt(attributes[0].value_id) != valueId) {
                    return false;
                }

                return true;
            }
        );

        if (availableVariantsForAttribute.length >= 1) {
            //console.log('availabilityQuestionAttribute -> znaleziony wariant');

            const modalRef = this.ModalService.add(
                'Powiadomienie o dostępności',
                `<product-view-availability-question product-id="${this.product.id}" variant-id="${availableVariantsForAttribute[0].id}" product-name="'${this.product.name} (wariant: ${availableVariantsForAttribute[0].id})'" attribute-id="0" attribute-value-id="0"></product-view-availability-question>`
            );

            modalRef.open();
        } else {
            //console.log('availabilityQuestionAttribute -> nieznaleziony wariant');

            const modalRef = this.ModalService.add(
                'Powiadomienie o dostępności',
                `<product-view-availability-question product-id="${this.product.id}" variant-id="0" product-name="'${this.product.name}'" attribute-id="${attributeId}" attribute-value-id="${valueId}" attribute-name="'${attributeName}'" attribute-value-name="'${valueName}'"></product-view-availability-question>`
            );

            modalRef.open();
        }
    }

    availabilityQuestionColor(colorId, colorName) {
        const modalRef = this.ModalService.add(
            'Powiadomienie o dostępności',
            `<product-view-availability-question product-id="${this.product.id}" variant-id="0" product-name="'${this.product.name} - kolor: ${colorName}'" attribute-id="0" attribute-value-id="${colorId}" attribute-name="'Kolor'" attribute-value-name="'${colorName}'"></product-view-availability-question>`
        );

        modalRef.open();
    }

    checkAttributesAvaibilityForFrame() {

        let availableVariants = this.variants;

        // Don't display colors not available for the selected frame type
        let attributeValues = new Map();
        let attributesColors = new Map();

        // Get all colors available for the each of an attribute values
        availableVariants.forEach(variant => {
            variant.attributes.forEach(variantAttribute => {
                // Store the colors available for a specific variant values
                const attribute_id = parseInt(variantAttribute.attribute_id);
                const value_id = parseInt(variantAttribute.value_id);

                let variantAttributeColors = attributesColors.get(attribute_id);
                if (!variantAttributeColors) {
                    variantAttributeColors = new Map();
                }
                let colorsList = variantAttributeColors.get(value_id);
                if (!colorsList) {
                    colorsList = new Map();
                }

                colorsList.set(parseInt(variant.color_id), parseInt(variant.color_id));
                variantAttributeColors.set(value_id, colorsList);
                attributesColors.set(attribute_id, variantAttributeColors);

                // Store the attributes available for a specific variant values
                let variantAttributeValues = attributeValues.get(attribute_id);
                if (!variantAttributeValues) {
                    variantAttributeValues = new Map();
                }
                let otherAttributes = variantAttributeValues.get(value_id);
                if (!otherAttributes) {
                    otherAttributes = new Map();
                }

                variant.attributes.forEach(otherVariantAttribute => {
                    const other_attribute_id = parseInt(otherVariantAttribute.attribute_id);
                    const other_value_id = parseInt(otherVariantAttribute.value_id);

                    if (other_attribute_id === attribute_id) {
                        return;
                    }

                    let otherAttributesValues = otherAttributes.get(other_attribute_id);

                    if (!otherAttributesValues) {
                        otherAttributesValues = new Map();
                    }

                    otherAttributesValues.set(other_value_id, other_value_id);
                    otherAttributes.set(other_attribute_id, otherAttributesValues);
                });

                variantAttributeValues.set(value_id, otherAttributes);
                attributeValues.set(attribute_id, variantAttributeValues);
            });
        });

        console.log('attributesColors', attributesColors);

        if(this.selectedAttributes.get(this.frameAttributeId) && this.selectedAttributes.get(this.frameAttributeId) > 0) {
            // Hide colors not available for the selected frame type
            const selectedFrameSize = parseInt(this.selectedAttributes.get(this.frameAttributeId));
            const selectedFrameColors = attributesColors.get(this.frameAttributeId).get(selectedFrameSize);
            let availableColors = [];

            if(!selectedFrameColors) {
                return;
            }

            this.colors.forEach((color, color_id) => {
                color.hidden = !selectedFrameColors.has(color_id);
                if(selectedFrameColors.has(color_id)) {
                    availableColors.push(color_id);
                }
            });

            // Hide attributes not available for the selected frame type
            const availableAttributesValues = attributeValues.get(this.frameAttributeId).get(selectedFrameSize);

            this.attributes.forEach((attribute, attribute_id) => {

                if(attribute_id === this.frameAttributeId) {
                    return;
                }

                const availableValues = availableAttributesValues.get(attribute_id);

                for(let value of attribute.values) {
                    value.hidden = !availableValues.has(value.id);
                }
            });

        } else {
            this.colors.forEach((color, color_id) => {
                color.hidden = false;
            });
            this.attributes.forEach((attribute, attribute_id) => {
                for(let value of attribute.values) {
                    value.hidden = false;
                }
            });
        }

    }

    checkAttributesAvaibility() {

        let availableVariants = this.variants; //this.variants.filter(variant => parseInt(variant.can_buy) == 1);
        let tmpAvailableVariants = availableVariants;

        if (this.selectedColorId) {
            tmpAvailableVariants = availableVariants = availableVariants.filter(variant => parseInt(variant.color_id) == this.selectedColorId);
        }

        this.availableAttributes = {};

        for (let [attributeId, attribute] of this.attributes) {

            let allMatchesForAttribute = [];

            for (const value of attribute.values) {

                const availableVariantsForAttributeValue = availableVariants.filter(
                    variant => {

                        const attributes = variant.attributes.filter(
                            attribute => parseInt(attribute.attribute_id) == attributeId
                        );

                        if (!attributes || attributes.length < 1) return false;

                        if (parseInt(attributes[0].value_id) != value.id) return false;

                        return true;
                    }
                );

                allMatchesForAttribute = allMatchesForAttribute.concat(availableVariantsForAttributeValue);

                value.available = (availableVariantsForAttributeValue.length > 0);

                if (this.selectedAttributes.get(attributeId) == value.id && !value.available) {
                    this.selectedAttributes.set(attributeId, -1);
                }
            }

            if (this.selectedAttributes.get(attributeId) > 0) {
                availableVariants = availableVariants.filter(
                    variant => {
                        const attributes = variant.attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                        if (!attributes || attributes.length < 1) return false;

                        if (parseInt(attributes[0].value_id) != this.selectedAttributes.get(attributeId)) return false;

                        return true;
                    }
                );
            } else {
                availableVariants = allMatchesForAttribute;

                const attributes = allMatchesForAttribute[0].attributes.filter(attribute => parseInt(attribute.attribute_id) == attributeId);

                if (!attributes || attributes.length < 1) return;

                this.selectedAttributes.set(attributeId, attributes[0].value_id);
            }
        }

        let validAttributes = {};

        // Remove invalid attributes combinations
        this.attributes.forEach((attribute, attributeId) => {
            let matching = {};
            this.selectedAttributes.forEach((selectedAttributeValue, selectedAttributeId) => {
                if (selectedAttributeValue !== -1 && selectedAttributeId != attributeId) {
                    matching[selectedAttributeId] = selectedAttributeValue;
                }
            });
            tmpAvailableVariants.forEach((variant) => {
                let match = 0;
                variant.attributes.forEach(attribute => {
                    if (matching[attribute.attribute_id] == attribute.value_id) {
                        match++;
                    }
                });
                if (match === Object.keys(matching).length) {
                    variant.attributes.forEach(attribute => {
                        if (!validAttributes[attribute.attribute_id]) {
                            validAttributes[attribute.attribute_id] = {};
                        }
                        validAttributes[attribute.attribute_id][attribute.value_id] = 1;
                    });
                }
            });
        });

        this.attributes.forEach((attribute, attributeId) => {
            attribute.values.forEach(value => {
                if (validAttributes[attributeId] && !validAttributes[attributeId][value.id]) {
                    value.available = false;
                }
            });
        });

        console.log('Selected variant', this.selectedVariant);

        if(!this.selectedVariant) {
            console.log('Selected variant #2', availableVariants[0]);
            this.selectVariant(availableVariants[0]);
        }
    }

    chooseDefaultImage() {
        if (!this.images || this.images.length < 1) return null;

        let defaultProductImage = this.images.filter(
            image => !image.variant_id && image.default
        )[0];

        if (defaultProductImage === undefined) {
            defaultProductImage = this.images[0];
        }

        if (!this.selectedVariant) {
            this.currentImage = defaultProductImage;
            return this.currentImage;
        }

        const variantsDefaultImage = this.images.filter(
            image => image.variant_id == this.selectedVariant && image.default
        );

        if (variantsDefaultImage.length < 1) {
            this.currentImage = defaultProductImage;
            return this.currentImage;
        }

        this.currentImage = variantsDefaultImage[0];

        return this.currentImage;
    }

    changeCurrentImage(url) {
        const images = this.images.filter(
            image => image.url == url
        );

        if (images.length < 1) return;

        this.currentImage = images[0];
    }

    calculatePrice() {
        const complementaryProductPriceGros = this.selectedComplementaryProduct ? this.selectedComplementaryProduct.price_gros : 0;

        if(this.selectedVariant) {
            const selectedVariant = this.variants.find(variant => variant.id === this.selectedVariant);
            this.price = {
                from: false,
                catalog_price: selectedVariant.catalog_price,
                price_old_gros: selectedVariant.price_old_gros + complementaryProductPriceGros,
                price_gros: selectedVariant.price_gros + complementaryProductPriceGros,
                omnibus_lowest_price: selectedVariant.omnibus_lowest_price
            };
        } else {
            this.price = {
                from: true,
                catalog_price: this.product.catalog_price,
                price_old_gros: this.product.old_price,
                price_gros: this.product.min_price,
                omnibus_lowest_price: this.product.omnibus_lowest_price
            };
        }

        this.ProductViewService.setPrice(this.price);
    }

    getPercentageDiffForOmnibusLowerPrice(omnibus_lowest_price, price_gros) {
        let diff = Math.round(((omnibus_lowest_price - price_gros) / omnibus_lowest_price) * 100);

        if (diff > 0) {
            return '+' + diff + '%';
        } else {
            return diff + '%';
        }
    }

    selectVariant(variant) {
        console.log('selectVariant()', variant);

        if (!variant || !variant.can_buy) {
            this.calculatePrice();
            this.availability = {
                name: null,
                quantity: this.product.quantity
            };
            this.productCode = null;
            this.eanCode = null;
            this.selectedVariant = null;
            this.chooseDefaultImage();

            return;
        }

        if (this.selectedVariant) {
            let segments = this.$location.path().split('/');

            segments[segments.length - 1] = variant.slug;

            this.$location.path(segments.join('/'));
        } else {
            let path = `${this.$location.path()}/${variant.slug}`;

            this.$location.path(path);
        }

        this.selectedVariant = variant.id;

        if (variant.color_id) {
            console.log('selectVariant -> color_id', parseInt(variant.color_id))
            // this.selectedColorId = parseInt(variant.color_id);
        }

        this.chooseDefaultImage();
        this.calculatePrice();
        this.productCode = variant.product_code;
        this.eanCode = variant.barcode;
        this.availability = {
            id: variant.avail_id,
            name: variant.displayed_availability,
            quantity: variant.quantity
        };

        this.ProductViewService.setVariant(variant)
    }

    increaseQuantity() {
        this.quantity = parseInt(this.quantity) + 1;
    }

    decreaseQuantity() {
        this.quantity = Math.max(0, parseInt(this.quantity) - 1);
    }

    transformUrlEncoded(data) {
        return this.$httpParamSerializer(data);
    }

    parseFloat(val) {
        return parseFloat(val);
    }

    get formatedSchemaPrice() {
        if (!this.price || !this.price.price_gros) {
            return 0;
        }

        return parseFloat((this.price.price_gros + '').replace(' ', '').replace(',', '.'));
    }

    get priceValidUntil() {
        let date = new Date();
        date.setDate(date.getDate() + 14);

        return date.toISOString().slice(0, 10);
    }

    get currentUrl() {
        return this.$location.url();
    }

    buy() {
        this.loading = true;

        let variant = null;
        let complementaryProducts = [];
        let requests = [];

        if (this.selectedVariant) {
            variant = parseInt(this.selectedVariant);
        }

        if (this.selectedComplementaryProduct) {
            complementaryProducts.push(this.selectedComplementaryProduct.id);
        }

        this.$http.post(
            '/ajax/checkout/add-to-cart',
            {
                productId: parseInt(this.product.id),
                variantId: variant,
                quantity: parseInt(this.quantity),
                complementaryProductId: complementaryProducts
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    return;
                }

                const message = response.data.message.content;

                this.CartService.load();

                const modalRef = this.ModalService.add(
                    'Produkt dodany do koszyka',
                    `<div class="product-add-to-cart-modal">
                        <img ng-src="${this.defaultPhoto.url}" alt="${this.name}" />
                        <p>${message}</p>
                    </div>
                    <div class="button-container">
                        <button class="btn btn-grey" type="button" ng-click="$ctrl.close()">Kontynuuj zakupy</button>
                        <a class="btn btn-blue" href="/koszyk">Przejdź do koszyka (<cart-count count="0"></cart-count>)</a>
                    </div>`
                );

                modalRef.open();

                if (typeof window.gtag === 'undefined') {
                    return;
                }

                // Fallback to product/variant ID
                let productCode = this.product.id;

                if (variant) {
                    productCode = variant;
                }

                if (this.productCode) {
                    productCode = this.productCode;
                }

                console.log(`gtag::event::add_to_cart -> dodanie -> ${productCode}`);

                let productPrice = response.data.message.product_price.toString();
                const productName = this.name;
                const productCategoryName = this.product.category_name;
                const productQuantity = parseInt(this.quantity);

                window.gtag('event', 'add_to_cart', {
                    "value": parseFloat(productPrice.replace(' ', '').replace(',', '.').replace(/(\d+),(\d+).*/, '$1.$2')),
                    "currency": "PLN",
                    "items": [
                        {
                            "id": productCode,
                            "name": productName,
                            "category": productCategoryName,
                            "quantity": productQuantity,
                            "price": parseFloat(productPrice.replace(' ', '').replace(',', '.').replace(/(\d+),(\d+).*/, '$1.$2'))
                        }
                    ]
                });
            },
            (response) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }
}

let productViewComponent = {
    bindings: {
        product: '<',
        images: '<',
        variants: '<',
        complementaryProducts: '<',
        selectedVariant: '<',
        attributesToFilter: '<',
        sizeTable: '<',
        framesDescription: '<'
    },
    template: productViewHtml,
    controller: ProductViewController
};

export default productViewComponent;
